<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import DevicePixelRatio from './libs/rem'
export default {
  name: 'App',
  created(){
    new DevicePixelRatio().init()
  },
  mounted() {
    /* 设置PC端移动端路由 */
    if (this._isMobile()) {
      // 跳转至手机端路由
      //alert("手机端");
      this.$router.replace("/MHome");
    } else {
      // 跳转至 pc 端路由
      //alert("pc端");
      this.$router.replace("/");
    }
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue